import React from "react";
import { Link } from "react-router-dom";

/**
 * Draft & Defend wordmark logo.
 * variant: "navy" (for light backgrounds) | "white" (for dark backgrounds)
 */
export default function Logo({ variant = "navy", showUrl = true, className = "", asLink = true }) {
  const textColor = variant === "white" ? "#FFFFFF" : "#0B1B3D";
  const urlColor = variant === "white" ? "#CBD5E1" : "#475569";
  const gold = "#D4AF37";

  const content = (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      {/* Shield + quill emblem */}
      <svg
        viewBox="0 0 64 72"
        className="h-10 w-auto flex-shrink-0 sm:h-11"
        aria-hidden="true"
      >
        <path
          d="M32 2 L60 12 V34 C60 52 47 64 32 70 C17 64 4 52 4 34 V12 Z"
          fill="none"
          stroke={gold}
          strokeWidth="3.5"
        />
        <path
          d="M32 9 L53 16.5 V34 C53 48 43 57.5 32 62.5 C21 57.5 11 48 11 34 V16.5 Z"
          fill={gold}
          opacity="0.12"
        />
        {/* Quill */}
        <path
          d="M42 20 C33 25 26 33 23 45 L27 45 C30 35 36 28 44 23 Z"
          fill={gold}
        />
        <path
          d="M22 48 L26 44 L29 47 L25 51 Z"
          fill={gold}
        />
        <line x1="20" y1="52" x2="34" y2="52" stroke={gold} strokeWidth="2.4" strokeLinecap="round" />
      </svg>

      {/* Wordmark */}
      <div className="flex flex-col leading-none">
        <span
          className="font-serif font-bold tracking-tight"
          style={{ color: textColor, fontSize: "1.32rem", lineHeight: 1.05 }}
        >
          DRAFT <span style={{ color: gold }}>&amp;</span> DEFEND
        </span>
        {showUrl && (
          <span
            className="mt-1 font-medium"
            style={{
              color: urlColor,
              fontSize: "0.6rem",
              letterSpacing: "0.14em",
            }}
          >
            WWW.DRAFTANDDEFEND.COM
          </span>
        )}
      </div>
    </div>
  );

  if (!asLink) return content;
  return (
    <Link to="/" data-testid="logo-link" className="inline-flex items-center">
      {content}
    </Link>
  );
}
